import { render, staticRenderFns } from "./loginpage.vue?vue&type=template&id=af0c670e&scoped=true"
import script from "./loginpage.vue?vue&type=script&lang=js"
export * from "./loginpage.vue?vue&type=script&lang=js"
import style0 from "./loginpage.vue?vue&type=style&index=0&id=af0c670e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0c670e",
  null
  
)

export default component.exports
import {QInput,QBtn,QDialog,QCard,QCardSection,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QBtn,QDialog,QCard,QCardSection})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
